import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-promotion-log',
  templateUrl: './promotion-log.component.html',
  styleUrls: ['./promotion-log.component.scss']
})
export class PromotionLogComponent {

  public data: any = { match: "exact" };
  public load: any = false;
  public items: any = [];
  public games: any = []

  private selected_company: any = null;
  constructor(private http: HttpService, private activatedRoute: ActivatedRoute, private router: Router) {
    this.selected_company = this.http.getStaticSelectedCompany();

    let queryParams = this.activatedRoute.snapshot.queryParams;
    let available = false;

    if (queryParams.date_from) {
      this.data.date_from = queryParams.date_from;
      available = true;
    }
    if (queryParams.date_to) {
      this.data.date_to = queryParams.date_to;
      available = true;
    }
    if (queryParams.code) {
      this.data.code = queryParams.code;
      available = true;
    }
    if (queryParams.mobile) {
      this.data.mobile = queryParams.mobile;
      available = true;
    }
    if (queryParams.match) {
      this.data.match = queryParams.match;
      available = true;
    }

    if (available) {
      this.filter()
    } else {
      this.init()
    }
  }

  async init() {
    let date = new Date();
    this.data.date_from = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2) + "T00:00"
    this.data.date_to = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2) + "T23:59"
  }

  async filter() {

    this.load = true;
    let y: any = await this.http.post("/admin/promotion/log", this.data);

    if (y.status && y.items) {
      this.items = y.items;

      const queryParams = { ...this.data };
      this.router.navigate(['/lo', this.selected_company, 'promotion-log'], { queryParams: queryParams, replaceUrl: true });
    }

    this.load = false;

  }

  statusUpdate(status) {
    switch (status) {
      case 0:
        return "Completed";
      case 1:
        return "Pending";
      case 9:
        return "Canceled"
    }
  }

  sum(key: string) {
    return this.items.reduce((acc: any, item: any) => acc + parseFloat(item[key] ?? 0), 0);
  }

  viewGameLog(item: any) {
    let company = this.http.getStaticSelectedCompany();
    let date_from = item.timestamp.replace(" ", "T").substring(0, 19);

    let queryParams: any = {
      code: item.code,
      date_from: date_from,
      match: 'exact',
      is_promo: 1
    };

    if (item.update_timestamp) {
      queryParams.date_to = item.update_timestamp.replace(" ", "T").substring(0, 19);
    }

    this.router.navigate(['/lo', company, 'game-log'], {
      queryParams: queryParams
    });
  }

}
